import styled from 'styled-components';

import { ConnectSurface } from '@/components/Pretzel/ConnectSurface';

export const SurfaceWidget = styled(ConnectSurface)`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
